function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.555,
    height: 22.276,
    viewBox: "0 0 45.555 22.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "04d"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184453"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14414",
    d: "M458.936 48.071a5.216 5.216 0 0 1 2.623-.7 5.147 5.147 0 0 1 4.952 3.616 6.1 6.1 0 0 1 .627.269 6.845 6.845 0 1 0-11.5-6.24 8.455 8.455 0 0 1 3.298 3.055z",
    transform: "translate(-439.289 -39.528)",
    style: {
      fill: "#ff8826"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14415",
    d: "M514.157 58.065a6 6 0 0 0-6.025-5.1 6.1 6.1 0 0 0-5.451 3.265 3.431 3.431 0 0 0-.319-.215v.166a7.393 7.393 0 0 1-2.11 5.192 5.919 5.919 0 0 1 2.8 4.6h10.198a4.093 4.093 0 0 0 4.157-4 4.053 4.053 0 0 0-3.25-3.908z",
    transform: "translate(-471.852 -49.333)",
    style: {
      fill: "#e06d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184455"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184454"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14416",
    d: "M530.259 57.845a3.97 3.97 0 0 1 3.676 2.607c.151.4.8.229.651-.18a4.668 4.668 0 0 0-4.327-3.1.338.338 0 0 0 0 .676z",
    transform: "translate(-493.51 -52.402)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184459"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14417",
    d: "M421.849 65.256a4.5 4.5 0 0 0-4.444-3.481 4.625 4.625 0 0 0-2.83.957 8.055 8.055 0 0 0-7.2-4.31 7.923 7.923 0 0 0-7.954 6.736 5.35 5.35 0 0 0-4.289 5.151 5.4 5.4 0 0 0 5.487 5.282h19.633a5.4 5.4 0 0 0 5.487-5.282 5.331 5.331 0 0 0-3.89-5.053z",
    transform: "translate(-395.135 -53.317)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184457"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14418",
    d: "M419.332 65.3a6.362 6.362 0 0 1 5.154-2.751.381.381 0 0 0 0-.762 7.167 7.167 0 0 0-5.811 3.128c-.282.4.378.784.658.385z",
    transform: "translate(-412.263 -55.77)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184458"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14419",
    d: "M399.668 92.206a4.141 4.141 0 0 1 1.941-3.45c.412-.263.03-.923-.384-.658a4.929 4.929 0 0 0-2.319 4.108.381.381 0 0 0 .762 0z",
    transform: "translate(-397.886 -74.93)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04D);
export default __webpack_public_path__ + "static/media/04D.bc71043af0c7878000bcf5ed0ec39aa7.svg";
export { ForwardRef as ReactComponent };